module.exports = __webpack_public_path__ + "logo.png?d6a25763698070c8d57597a6d28fabfa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 181
// module chunks = 0